import {Box, Toolbar, AppBar, Stack, Button, Tooltip, IconButton, Container} from "@mui/material";
import {useNavigate, useNavigation, Outlet, NavLink, useLoaderData} from "react-router-dom"
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AuthProvider from "../../hooks/authProvider";
import KeyIcon from '@mui/icons-material/Key';
import FilterComponent from "./filter";
import axios from "axios";
import PageTitle from "../../components/PageTitle";
import {isPartner, isSuperAdmin} from "../../auth/permissions";

export async function loader({request, params}) {
    const searchParam = (new URL(request.url)).searchParams;
    const queryString = new URLSearchParams(searchParam).toString();
    const city = searchParam.get('city');
    const booking_from = searchParam.get('booking_from');
    const booking_to = searchParam.get('booking_to');

    const cacheKey = `filter_cache_${city}_${booking_from}_${booking_to}`;
    const CACHE_DURATION_MS = 10 * 60 * 1000; // 10 минут
    const now = Date.now();

    const cachedData = localStorage.getItem(cacheKey);
    let filter;

    if (cachedData) {
        try {
            const parsed = JSON.parse(cachedData);
            if (parsed.timestamp && now - parsed.timestamp < CACHE_DURATION_MS) {
                //console.log('Loaded filter data from cache ✅');
                filter = parsed.data;
            } else {
                localStorage.removeItem(cacheKey);
            }
        } catch (error) {
            //console.error('Ошибка чтения кеша фильтра:', error);
            localStorage.removeItem(cacheKey);
        }
    }

    if (!filter) {
        const response = await axios.get(`/api/booking_modules/use/filtr/?${queryString}`);
        filter = response.data;
        localStorage.setItem(cacheKey, JSON.stringify({
            data: filter,
            timestamp: Date.now()
        }));
    }

    const authenticated = await AuthProvider.checkAuth();
    const stringifiedSearch = searchParam.toString();
    return {filter, searchParams: searchParam, authenticated, stringifiedSearch};
}

export default function BookingModuleLayout() {
    const navigation = useNavigation();
    const navigate = useNavigate();
    const user = AuthProvider.user;
    const loaderData = useLoaderData();
    return (
        <>
            <PageTitle title="Модуль бронювання" />
            <Box sx={{flexGrow: 1}}>
                <AppBar elevation={0} position="static" sx={{backgroundColor: 'white', color: 'black'}}>
                    <Toolbar sx={{justifyContent: 'space-between'}}>
                        <Box className='flex-placeholder'/>
                        <Box className='box-links'>
                        </Box>
                        <Box>

                            {loaderData.authenticated ? (
                                <Stack direction='row'>
                                    {isPartner(user) && <Button component={NavLink} to='/calendar' color='inherit'>Кабінет партнера</Button>}
                                    {isSuperAdmin(user) && <Button component={NavLink} to='/adminH123H' color='inherit'>Адміністративна панель</Button>}
                                    <Button
                                        startIcon={<AccountCircleOutlinedIcon/>}
                                        component={NavLink}
                                        to='/profile/details'
                                        color='inherit'
                                        variant='text'
                                        className="nav-link"
                                    >
                                        {user?.username || 'Профіль'}
                                    </Button>

                                    <Tooltip title='Вийти'>
                                        <IconButton
                                            onClick={() => {
                                                navigate('/logout')
                                            }}
                                            color='inherit'
                                            className="nav-link"
                                        >
                                            <LogoutIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            ) : (
                                <Button
                                    startIcon={<KeyIcon/>}
                                    component={NavLink}
                                    to='/login'
                                    color='inherit'
                                    variant='text'
                                    className="nav-link"
                                >
                                    Увійти
                                </Button>
                            )}

                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <Container maxWidth='lg'>
                <Box>
                    <FilterComponent loaderData={loaderData}/>
                </Box>
                <Box className={
                    navigation.state === "loading" ? "loading" : ""
                }>

                    <Outlet/>

                </Box>
            </Container>
        </>
    )
}
